import { SchoolPage_school_profile } from '../gql'

enum SectionKey {
  ABOUT = 'about',
  ADMISSIONS = 'admissions',
  LOCATION = 'location',
  PHILOSOPHY = 'philosophy',
  TEACHERS = 'teachers',
  TESTIMONIALS = 'testimonials',
}

export interface ISectionContent {
  markdown: string
}

type ProfileContent = {
  [key in SectionKey]: ISectionContent | null
}

export function parseProfileContent(profile: SchoolPage_school_profile): ProfileContent {
  const parsed = JSON.parse(profile.content).reduce((sections: any, current: any) => {
    sections[current.key] = current
    return sections
  }, {})

  return {
    [SectionKey.ABOUT]: parsed[SectionKey.ABOUT] || null,
    [SectionKey.ADMISSIONS]: parsed[SectionKey.ADMISSIONS] || null,
    [SectionKey.LOCATION]: parsed[SectionKey.LOCATION] || null,
    [SectionKey.PHILOSOPHY]: parsed[SectionKey.PHILOSOPHY] || null,
    [SectionKey.TEACHERS]: parsed[SectionKey.TEACHERS] || null,
    [SectionKey.TESTIMONIALS]: parsed[SectionKey.TESTIMONIALS] || null,
  }
}
